export default "__VITE_ASSET__7f763d9e__"